<template>
  <BigNumberParent>
    <div style="position: relative" ref="chartcontainer">
      <div
        :style="{
          width: `${sparklineWidth}px`,
          height: `${sparklineHeight}px`,
          padding: '',
          position: 'absolute',
          bottom: 0,
          left: 0
        }"
      >
        <div
          class="sparklineTooltip"
          ref="sparklineTooltip"
          :style="{ position: 'absolute', pointerEvents: 'none' }"
        ></div>
        <BigNumberFaelleZeitraumBars
          :austria_timeline="timeline_comparable"
          :colors="colors"
          :format="format"
          :styles="{
            width: `${sparklineWidth}px`,
            height: `${sparklineHeight}px`
          }"
          v-if="sparklineWidth && sparklineHeight"
        >
        </BigNumberFaelleZeitraumBars>
        <div class="xaxislabels">
          <!-- x axis labels -->
          <div>{{ datefmt(combined_latest_days[0], "YYYY-MM-DD") }}</div>
          <div>
            {{ datefmt(combined_latest_days[combined_latest_days.length - 1]) }}
          </div>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-left">
          <div
            class="dg-value"
            :style="{
              color: this.selected_xvalue
                ? this.colors.infizierte_highlight
                : this.colors.infizierte
            }"
          >
            <span style="display: inline-block">
              <span v-html="`${$fmt(',d')(this.at_number)}`"></span>
            </span>
          </div>
          <h6>
            neu bestätigte Fälle
            <br />
            <span style="font-weight: normal">
              {{
                this.selected_xvalue
                  ? `am ${datefmt(this.selected_xvalue)}`
                  : "in den letzten 14 Tagen"
              }}
            </span>
          </h6>
        </div>
        <div
          class="flex-right"
          :style="{ marginBottom: `${sparklineHeight - 8}px` }"
        >
          <div
            class="dg-value"
            :style="{ color: this.colors.davon_max_aktive }"
          >
            <span style="display: inline-block">
              <span v-html="`${$fmt(',d')(this.max_aktive_bl_number)}`"></span>
            </span>
          </div>
          <h6>
            davon in {{ this.active_max_latest.land }}<br />
            <span :style="{ color: this.colors.davon_max_aktive }">
              ({{ $fmt(".0f")((100 * max_aktive_bl_number) / at_number) }} %)
            </span>
          </h6>
        </div>
        <div
          style="position: absolute; bottom: 0; width: 100%; text-align:center; font-size: 8px; margin-bottom: -9px;"
        >
          Datum des Testergebnisses
        </div>
      </div>
    </div>
  </BigNumberParent>
</template>
<script>
import BigNumberFaelleZeitraumBars from "./BigNumberFaelleZeitraumBars.vue";
import BigNumberParent from "./BigNumberParent.vue";
import ComponentSizeMixin from "./ComponentSizeMixin";
import moment from "moment";

export default {
  name: "BigNumberFaelleZeitraum",
  components: {
    BigNumberFaelleZeitraumBars,
    BigNumberParent
  },
  mixins: [ComponentSizeMixin],
  props: {
    austria_timeline: Array,
    bundeslaender_timeline: Array,
    colors: Object,
    sparkline: Array,
    sparkline_keys: Array,
    mobile: String,
    format: {
      type: String,
      default: ",.0f"
    },
    ndays: {
      type: Number,
      default: 14
    },
    active_max_latest: Object
  },
  data: () => ({
    selected_xvalue: null
  }),
  mounted() {},
  methods: {
    datefmt(x) {
      return moment(x).format("D. MMMM");
    },
    select_xvalue(xvalue) {
      this.selected_xvalue = xvalue;
    }
  },
  computed: {
    sparklineWidth() {
      if (!this.chartcontainerWidth) {
        return null;
      }
      return this.chartcontainerWidth;
    },
    sparklineHeight() {
      return 65;
    },
    austria_timeline_days() {
      var r = [];
      this.austria_timeline.forEach(d => {
        if (r.indexOf(d.date) < 0) {
          r.push(d.date);
        }
      });
      r.sort();
      return r;
    },
    max_aktive_bl_timeline_per_day() {
      var r = {};
      this.bundeslaender_timeline.forEach(d => {
        if (d.land == this.active_max_latest.land) {
          r[d.datum] = d;
        }
      });
      return r;
    },
    combined_latest_days() {
      return this.austria_timeline_days.filter(
        (d, i) =>
          i >= this.austria_timeline_days.length - this.ndays &&
          this.max_aktive_bl_timeline_per_day[d] !== undefined
      );
    },
    timeline_comparable() {
      return this.austria_timeline
        .filter(d => this.combined_latest_days.indexOf(d.date) >= 0)
        .map(d => {
          var r = {};
          r.date = d.date;
          r.bestätigte_Fälle_tag_diff = +d.bestätigte_Fälle_tag_diff;
          r.davon_max_aktive = this.max_aktive_bl_timeline_per_day[
            d.date
          ].bestätigte_Fälle_tag_diff;
          return r;
        });
    },
    summe_at() {
      return this.timeline_comparable
        .map(d => d.bestätigte_Fälle_tag_diff)
        .reduce((a, b) => a + b, 0);
    },
    summe_max_aktive_bl() {
      return this.timeline_comparable
        .map(d => d.davon_max_aktive)
        .reduce((a, b) => a + b, 0);
    },
    selected_date_obj() {
      return this.selected_xvalue
        ? this.timeline_comparable.filter(
            d => d.date == this.selected_xvalue
          )[0]
        : null;
    },
    at_number() {
      return this.selected_xvalue
        ? this.selected_date_obj.bestätigte_Fälle_tag_diff
        : this.summe_at;
    },
    max_aktive_bl_number() {
      return this.selected_xvalue
        ? this.selected_date_obj.davon_max_aktive
        : this.summe_max_aktive_bl;
    }
  },
  provide() {
    return {
      getTooltipEl: function() {
        return this.$refs.sparklineTooltip;
      }.bind(this),
      setTooltipXValue: function(xvalue) {
        this.select_xvalue(xvalue);
      }.bind(this)
    };
  }
};
</script>

<style scoped>
.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  position: relative;
  pointer-events: none;

  font-variant-numeric: tabular-nums; /* high-level property          */
  -moz-font-feature-settings: "tnum"; /* low-level (old Firefox)      */
  -webkit-font-feature-settings: "tnum"; /* low-level (old Webkit)       */
  font-feature-settings: "tnum" on; /* low-level (all new browsers) */
}

.flex-row >>> .sparkline-wrap {
  display: inline-block;
  width: 33%;
  text-align: right;
}

.flex-left {
  width: 60%;
}

.flex-right {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding-top: 0px;
  width: 40%;
  text-align: right;
}

h6 {
  font-size: 14px;
  margin: 0;
  display: block;
  color: white;
}

.dg-value small {
  font-size: 12px;
}

table {
  padding-bottom: 15px;
  display: table-cell;
  border-collapse: collapse;
}

.dg-value {
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  vertical-align: baseline;
}

.flex-right .dg-value,
.flex-right h6 {
  font-weight: normal;
}

.flex-right h6 {
  text-align: right;
}

.dg-number {
  text-align: right;
}

.dg-number2 {
  text-align: right;
}

.dg-number2 span {
  width: 48px;
  text-align: right;
}

td,
th,
tr {
  vertical-align: baseline;
  line-height: 1;
  /*  text-shadow: 1px 1px 0px rgb(59, 58, 57), -1px -1px 0px rgb(59, 58, 57),
    1px -1px 0px rgb(59, 58, 57), -1px 1px 0px rgb(59, 58, 57); */
}

th {
  font-size: 10px;
  font-weight: normal;
  color: white;
  padding: 0px 4px;
}

td.diff {
  width: auto;
  text-align: left;
  font-size: 10px;
  font-weight: normal;
}

.bgspan {
  background: rgba(59, 58, 57, 0.85);
  border-radius: 3px;
  padding-left: 2px;
  padding-right: 2px;
}

.dg-value.value2 {
  font-size: 14px;
}

@media (min-width: 700px) {
  .cmc_normal .dg-value {
    font-size: 32px;
  }
  .cmc_normal .dg-value.value2 {
    font-size: 16px;
  }
}

@media (min-width: 900px) {
  .cmc_normal .dg-value {
    font-size: 36px;
  }

  .cmc_normal .dg-value.value2 {
    font-size: 18px;
  }

  .cmc_normal td.diff,
  .cmc_normal th {
    font-size: 12px;
  }
}

.sparklineTooltip {
  font-size: 10px;
  right: 10px;
}

.xaxislabels {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 10px;
  line-height: 10px;
}
</style>
